// SMS DEFAULT TYPE ID
const TYPE = {
    APPOINTMENT_CONFIRMATION: 1,
    APPOINTMENT_REMINDER: 2,
    MEDICAL_REMINDER: 13,
    APPOINTMENT_PREVISIT: 22
};

// SMS DEFAULT CONTENT
const CONTENT_DEFAULT = {
    [TYPE.MEDICAL_REMINDER]:
        "Reminder from {CLINIC_NAME}. {PATIENT_NAME} is due for {ITEM_NAME} on {REMINDER_DUE_DATE}. To schedule appt or unsubscribe: {CLINIC_PHONE}.",
    [TYPE.APPOINTMENT_CONFIRMATION]:
        "Msg from {CLINIC_NAME}. Appt for {PATIENT_NAME} is scheduled for {APPOINTMENT_DATE} at {APPOINTMENT_TIME}. To cancel or reschedule: {CLINIC_PHONE}.",
    [TYPE.APPOINTMENT_REMINDER]:
        "Reminder from {CLINIC_NAME}. {PATIENT_NAME}'s appt is on {APPOINTMENT_DATE} at {APPOINTMENT_TIME}. To cancel or reschedule: {CLINIC_PHONE}.",
    [TYPE.APPOINTMENT_PREVISIT]:
        "{PATIENT_NAME}'s appointment is starting soon ({APPOINTMENT_DATE} at {APPOINTMENT_TIME})."
};

// LIST OF SMS DEFAULTS
const DEFAULT_SMS = {
    [TYPE.MEDICAL_REMINDER]: {
        type: TYPE.MEDICAL_REMINDER,
        label: "Medical Reminder",
        content: CONTENT_DEFAULT[TYPE.MEDICAL_REMINDER],
        additionalVariables: [
            {
                label: "Item Name",
                value: "ITEM_NAME"
            },
            {
                label: "Reminder Due Date",
                value: "REMINDER_DUE_DATE"
            },
            {
                label: "Reminder Due Day",
                value: "REMINDER_DUE_DAY"
            }
        ],
        requiredVariables: [
            "{PATIENT_NAME}",
            "{ITEM_NAME}",
            "{REMINDER_DUE_DATE}"
        ],
        showToolTip: false,
        maxLength: 1500
    },
    [TYPE.APPOINTMENT_CONFIRMATION]: {
        type: TYPE.APPOINTMENT_CONFIRMATION,
        label: "Appointment Confirmation",
        content: CONTENT_DEFAULT[TYPE.APPOINTMENT_CONFIRMATION],
        requiredVariables: [
            "{PATIENT_NAME}",
            "{APPOINTMENT_DATE}",
            "{APPOINTMENT_TIME}"
        ],
        showToolTip: true,
        maxLength: 1400
    },
    [TYPE.APPOINTMENT_REMINDER]: {
        type: TYPE.APPOINTMENT_REMINDER,
        label: "Appointment Reminder",
        content: CONTENT_DEFAULT[TYPE.APPOINTMENT_REMINDER],
        requiredVariables: [
            "{PATIENT_NAME}",
            "{APPOINTMENT_DATE}",
            "{APPOINTMENT_TIME}"
        ],
        showToolTip: true,
        maxLength: 1400
    },
    [TYPE.APPOINTMENT_PREVISIT]: {
        type: TYPE.APPOINTMENT_PREVISIT,
        label: "Appointment Pre-visit",
        content: CONTENT_DEFAULT[TYPE.APPOINTMENT_PREVISIT],
        requiredVariables: [
            "{PATIENT_NAME}",
            "{APPOINTMENT_DATE}",
            "{APPOINTMENT_TIME}"
        ],
        showToolTip: true,
        maxLength: 1400
    }
};

export default {
    TYPE,
    DEFAULT_SMS,
    CONTENT_DEFAULT
};
